import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* ADMIN LOGIN */
export const adminLogin = (data) => {
  return api.post(ENDPOINTS.AUTH.ADMIN_LOGIN, data);
};

/* SELLER LOGIN */
export const sellerLogin = (data) => {
  return api.post(ENDPOINTS.AUTH.SELLER_LOGIN, data);
};

/* SELLER REGISTER */
export const sellerRegister = (data) => {
  return api.post(ENDPOINTS.AUTH.SELLER_REGISTER, data, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

/* BUYER LOGIN */
export const buyerLogin = (data) => {
  return api.post(ENDPOINTS.AUTH.BUYER_LOGIN, data);
};

/* BUYER REGISTER */
export const buyerRegister = (data) => {
  return api.post(ENDPOINTS.AUTH.BUYER_REGISTER, data);
};

/* LOGOUT */
export const logout = () => {
  return api.post(ENDPOINTS.AUTH.LOGOUT);
};

/* GET LOGGED USER */ 
// This function will be used to fetch the logged-in user's details from the backend using the /auth/me endpoint. It will return the user data if the request is successful, or null if there is an error (e.g., if the user is not authenticated).
export const getLoggedInUser = async () => {
  try {
    const res = await api.get(ENDPOINTS.AUTH.GET_ME);
    return res.data.data;
  } catch {
    return null;
  } 
};


/* SEND OTP */
export const sendOtp = (data) => {
  return api.post(
    ENDPOINTS.AUTH.SEND_OTP,
    data
  );
};

/* VERIFY OTP */
export const verifyOtp = (data) => {
  return api.post(
    ENDPOINTS.AUTH.VERIFY_OTP,
    data
  );
};

/* FORGOT PASSWORD */
export const forgotPassword = (data) => {
  return api.post(
    ENDPOINTS.PASSWORD.FORGOT_PASSWORD,
    data
  );
};

/* RESET PASSWORD */
export const resetPassword = (data) => {
  return api.post(
    ENDPOINTS.PASSWORD.RESET_PASSWORD,
    data
  );
};